import {GeoJsonFeature, RectAngle, SearchResult, SearchType} from '../schema';
import {Action} from 'redux';


/* 入力テキストの保持 */
interface SetTextPayload {text: string};
export interface SetTextAction extends Action {
  type: 'SET_TEXT',
  payload: SetTextPayload,
}
export const setText = (payload: SetTextPayload): SetTextAction => ({
  type: 'SET_TEXT',
  payload,
});


/* Geojsonの保持 */
interface SetGJFsPayload {
  target: 'all' | 'article' | 'focus';
  features: GeoJsonFeature[];
};
export interface SetGJFsAction extends Action {
  type: 'SET_GEOJSON_FEATURES',
  payload: SetGJFsPayload,
}
export const setGJFs = (payload: SetGJFsPayload): SetGJFsAction => ({
  type: 'SET_GEOJSON_FEATURES',
  payload,
});


/* Search Result */
interface SetSearchResultsPayload {results: SearchResult[]};
export interface SetSearchResultsAction extends Action {
  type: 'SET_SEARCH_RESULTS',
  payload: SetSearchResultsPayload,
}
export const setSearchResults = (payload: SetSearchResultsPayload): SetSearchResultsAction => ({
  type: 'SET_SEARCH_RESULTS',
  payload,
});


/* Pointer */
interface PointOnMapPayload {lnglat: [number, number] | undefined};
export interface PointOnMapAction extends Action {
  type: 'POINT_ON_MAP',
  payload: PointOnMapPayload,
}
export const pointOnMap = (payload: PointOnMapPayload): PointOnMapAction => ({
  type: 'POINT_ON_MAP',
  payload,
});


/* Move Map Center */
interface MoveMapCenterPayload {lnglat: [number, number]};
export interface MoveMapCenterAction extends Action {
  type: 'MOVE_MAP_CENTER',
  payload: MoveMapCenterPayload,
}
export const moveMapCenter = (payload: MoveMapCenterPayload): MoveMapCenterAction => ({
  type: 'MOVE_MAP_CENTER',
  payload,
});

/* rect angle */
export interface SetRectAngleAction extends Action {
  type: 'SET_RECT_ANGLE',
  payload: RectAngle,
};
export const setRectAngle = (payload: RectAngle): SetRectAngleAction => ({
  type: 'SET_RECT_ANGLE',
  payload,
});


/* searchType */
interface SetSearchTypePayload {searchType: SearchType}
export interface SetSearchTypeAction extends Action {
  type: 'SET_SEARCH_TYPE',
  payload: SetSearchTypePayload,
}
export const setSearchType = (payload: SetSearchTypePayload): SetSearchTypeAction => ({
  type: 'SET_SEARCH_TYPE',
  payload,
});

interface SetActiveArticlePayload {key: number | undefined};
export interface SetActiveArticleAction extends Action {
  type: 'SET_ACTIVE_ARTICLE',
  payload: SetActiveArticlePayload,
};
export const setActiveArticle = (payload: SetActiveArticlePayload): SetActiveArticleAction => ({
  type: 'SET_ACTIVE_ARTICLE',
  payload,
});

interface SetActiveLocationPayload {key: string | undefined};
export interface SetActiveLocationAction extends Action {
  type: 'SET_ACTIVE_LOCATION',
  payload: SetActiveLocationPayload,
};
export const setActiveLocation = (payload: SetActiveLocationPayload): SetActiveLocationAction => ({
  type: 'SET_ACTIVE_LOCATION',
  payload,
});

interface SetMapBoundsPayload {minLngLat: [number, number], maxLngLat: [number, number]};
export interface SetMapBoundsAction extends Action {
  type: 'SET_MAP_BOUNDS',
  payload: SetMapBoundsPayload,
};
export const setMapBounds = (payload: SetMapBoundsPayload): SetMapBoundsAction => ({
  type: 'SET_MAP_BOUNDS',
  payload,
});
